import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { LanguageService } from 'src/app/demo/service/language.service';
import { NgxTranslateModule } from 'src/app/translate.module';

@Component({
    selector: 'app-customer-profile-document-view',
    standalone: true,
    imports: [CommonModule, ButtonModule, CardModule, NgxTranslateModule],
    templateUrl: './customer-profile-document-view.component.html',
    styleUrl: './customer-profile-document-view.component.scss',
})
export class CustomerProfileDocumentViewComponent {
    blobUrl!: SafeResourceUrl;
    mimeType!: string;
    customerId!: string;
    documentId!: string;
    selectedLanguage!: any;
    title: string = '';

    translateService = inject(TranslateService);
    languageService = inject(LanguageService);
    config = inject(DynamicDialogConfig);
    ref = inject(DynamicDialogRef);

    ngOnInit() {
        this.blobUrl = this.config.data.blobUrl;
        this.documentId = this.config.data.documentId;
        this.mimeType = this.config.data.mimeType;
        this.title = this.config.data.title;

        this.initializeLocale();
    }

    initializeLocale() {
        this.languageService.currentLanguage$.subscribe((language) => {
            this.selectedLanguage = language;
            this.setLanguage(this.selectedLanguage);
        });
    }

    setLanguage(language: string) {
        this.translateService.use(language);
        this.languageService.setLanguage(language);
    }

    closeDialog() {
      this.ref.close()
    }
}
